import React from "react";
import CandidateContent from "../CandidateContent/CandidateContent";
import { Box } from "@mui/material";

const HiringPipeline: React.FC = () => {

    return (
        <Box sx={{ '& .MuiBox-root': { padding: 0 }, width: '100%' }}>
            <CandidateContent/>
        </Box>
    );
};

export default HiringPipeline;
